import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      appName: "Falak",
      tagline: "Where time meets the sky",
      currentTime: "Current Time",
      moonPhase: "Moon Phase",
      hijriCalendar: "Hijri Calendar",
      sunrise: "Sunrise",
      sunset: "Sunset",
      solarNoon: "Solar Noon",
      dayLength: "Day Length",
      hours: "hours",
      moonIllumination: "Illumination",
      moonAge: "Moon Age",
      days: "days",
      visible: "Visible",
      notVisible: "Not Visible",
      share: "Share",
      language: "Language",
      location: "Location",
      astronomicalData: "Astronomical Data",
      altitude: "Altitude",
      azimuth: "Azimuth",
      loading: "Loading...",
      day: "Day",
      month: "Month",
      year: "Year",
      nextNewMoonPreface: "Crescent birth of the month of",
      startOf: "Start of",
      exactTime: "Exact Time (UTC)",
      today: "Today",
      prayerTimes: "Prayer Times",
      nextPrayer: "Next prayer",
      after: "Will be in",
      qibla: "Qibla Direction",
      useMyLocation: "Use my current location",
      useMyLocationHint: "Your location is precisely detected, and all Falak data is calibrated to it."
    }
  },
  ar: {
    translation: {
      appName: "Falak",
      tagline: "حيث يلتقي الزمن بالسماء",
      currentTime: "الوقت الحالي",
      moonPhase: "طور القمر",
      hijriCalendar: "التقويم الهجري",
      sunrise: "الشروق",
      sunset: "الغروب",
      solarNoon: "الظهيرة الشمسية",
      dayLength: "طول النهار",
      hours: "ساعات",
      moonIllumination: "الإضاءة",
      moonAge: "عمر القمر",
      days: "أيام",
      visible: "مرئي",
      notVisible: "غير مرئي",
      share: "مشاركة",
      language: "اللغة",
      location: "الموقع",
      astronomicalData: "البيانات الفلكية",
      altitude: "الارتفاع",
      azimuth: "السمت",
      loading: "جاري التحميل...",
      day: "اليوم",
      month: "الشهر",
      year: "السنة",
      nextNewMoonPreface: "ولادة هلال شهر",
      startOf: "بداية شهر",
      exactTime: "التوقيت الدقيق (UTC)",
      today: "اليوم",
      prayerTimes: "مواقيت الصلاة",
      nextPrayer: "الصلاة القادمة",
      after: "ستكون بعد",
      qibla: "اتجاه القبلة",
      useMyLocation: "استخدم موقعي الحالي",
      useMyLocationHint: "موقعك الحالي محدَّد بدقة عالية، وكافة بيانات \"فلك\" تم ضبطها وفق هذا الموقع."
    }
  },
  id: {
    translation: {
      appName: "Falak",
      tagline: "Tempat waktu bertemu langit",
      currentTime: "Waktu Saat Ini",
      moonPhase: "Fase Bulan",
      hijriCalendar: "Kalender Hijriah",
      sunrise: "Matahari Terbit",
      sunset: "Matahari Terbenam",
      solarNoon: "Tengah Hari",
      dayLength: "Panjang Hari",
      hours: "jam",
      moonIllumination: "Pencahayaan",
      moonAge: "Usia Bulan",
      days: "hari",
      visible: "Terlihat",
      notVisible: "Tidak Terlihat",
      share: "Bagikan",
      language: "Bahasa",
      location: "Lokasi",
      astronomicalData: "Data Astronomi",
      altitude: "Ketinggian",
      azimuth: "Azimut",
      loading: "Memuat...",
      day: "Hari",
      month: "Bulan",
      year: "Tahun",
      nextNewMoonPreface: "Kelahiran bulan sabit bulan",
      startOf: "Awal",
      exactTime: "Waktu Tepat (UTC)",
      today: "Hari Ini",
      prayerTimes: "Waktu Salat",
      nextPrayer: "Salat berikutnya",
      after: "Akan tiba dalam",
      qibla: "Arah Kiblat",
      useMyLocation: "Gunakan lokasi saya saat ini",
      useMyLocationHint: "Lokasi Anda terdeteksi dengan presisi, dan semua data Falak telah dikalibrasi sesuai dengannya."
    }
  },
  ur: {
    translation: {
      appName: "Falak",
      tagline: "جہاں وقت اور آسمان ملتے ہیں",
      currentTime: "موجودہ وقت",
      moonPhase: "چاند کا مرحلہ",
      hijriCalendar: "ہجری تقویم",
      sunrise: "طلوع آفتاب",
      sunset: "غروب آفتاب",
      solarNoon: "زوال",
      dayLength: "دن کی لمبائی",
      hours: "گھنٹے",
      moonIllumination: "روشنی",
      moonAge: "چاند کی عمر",
      days: "دن",
      visible: "نظر آنے والا",
      notVisible: "نظر نہیں آتا",
      share: "اشتراک کریں",
      language: "زبان",
      location: "مقام",
      astronomicalData: "فلکی معلومات",
      altitude: "بلندی",
      azimuth: "سمت",
      loading: "لوڈ ہو رہا ہے...",
      day: "دن",
      month: "مہینہ",
      year: "سال",
      nextNewMoonPreface: "ماہ کے چاند کی پیدائش",
      startOf: "ابتدا",
      exactTime: "صحیح وقت (UTC)",
      today: "آج",
      prayerTimes: "نماز کے اوقات",
      nextPrayer: "اگلی نماز",
      after: "ہوگا بعد",
      qibla: "سمتِ قبلہ",
      useMyLocation: "میرا موجودہ مقام استعمال کریں",
      useMyLocationHint: "آپ کا مقام درست طریقے سے شناخت کیا گیا ہے، اور \"فلک\" کا تمام ڈیٹا اسی کے مطابق ترتیب دیا گیا ہے۔"
    }
  },
  fr: {
    translation: {
      appName: "Falak",
      tagline: "Où le temps rencontre le ciel",
      currentTime: "Heure Actuelle",
      moonPhase: "Phase Lunaire",
      hijriCalendar: "Calendrier Hégirien",
      sunrise: "Lever du Soleil",
      sunset: "Coucher du Soleil",
      solarNoon: "Midi Solaire",
      dayLength: "Durée du Jour",
      hours: "heures",
      moonIllumination: "Illumination",
      moonAge: "Âge de la Lune",
      days: "jours",
      visible: "Visible",
      notVisible: "Non Visible",
      share: "Partager",
      language: "Langue",
      location: "Emplacement",
      astronomicalData: "Données Astronomiques",
      altitude: "Altitude",
      azimuth: "Azimut",
      loading: "Chargement...",
      day: "Jour",
      month: "Mois",
      year: "Année",
      nextNewMoonPreface: "Naissance du croissant du mois",
      startOf: "Début de",
      exactTime: "Heure Exacte (UTC)",
      today: "Aujourd'hui",
      prayerTimes: "Heures de Prière",
      nextPrayer: "Prochaine prière",
      after: "Sera dans",
      qibla: "Direction de la Qibla",
      useMyLocation: "Utiliser ma position actuelle",
      useMyLocationHint: "Votre position est détectée avec précision, et toutes les données de Falak sont calibrées en conséquence."
    }
  },
  bn: {
    translation: {
      appName: "Falak",
      tagline: "যেখানে সময় আকাশের সাথে মিলিত হয়",
      currentTime: "বর্তমান সময়",
      moonPhase: "চাঁদের পর্যায়",
      hijriCalendar: "হিজরি ক্যালেন্ডার",
      sunrise: "সূর্যোদয়",
      sunset: "সূর্যাস্ত",
      solarNoon: "সৌর দুপুর",
      dayLength: "দিনের দৈর্ঘ্য",
      hours: "ঘণ্টা",
      moonIllumination: "আলোকসজ্জা",
      moonAge: "চাঁদের বয়স",
      days: "দিন",
      visible: "দৃশ্যমান",
      notVisible: "অদৃশ্য",
      share: "শেয়ার করুন",
      language: "ভাষা",
      location: "অবস্থান",
      astronomicalData: "জ্যোতির্বিদ্যা তথ্য",
      altitude: "উচ্চতা",
      azimuth: "দিগংশ",
      loading: "লোড হচ্ছে...",
      day: "দিন",
      month: "মাস",
      year: "বছর",
      nextNewMoonPreface: "মাসের চাঁদের জন্ম",
      startOf: "শুরু",
      exactTime: "সঠিক সময় (UTC)",
      today: "আজ",
      prayerTimes: "নামাজের সময়",
      nextPrayer: "পরবর্তী নামাজ",
      after: "হবে",
      qibla: "কিবলার দিক",
      useMyLocation: "আমার বর্তমান অবস্থান ব্যবহার করুন",
      useMyLocationHint: "আপনার অবস্থান নির্ভুলভাবে শনাক্ত করা হয়েছে, এবং \"Falak\"-এর সমস্ত তথ্য সেই অনুযায়ী ক্যালিব্রেট করা হয়েছে।"
    }
  },
  zh: {
    translation: {
      appName: "Falak",
      tagline: "时间与天空相遇之处",
      currentTime: "当前时间",
      moonPhase: "月相",
      hijriCalendar: "希吉来历",
      sunrise: "日出",
      sunset: "日落",
      solarNoon: "太阳正午",
      dayLength: "白昼时长",
      hours: "小时",
      moonIllumination: "亮度",
      moonAge: "月龄",
      days: "天",
      visible: "可见",
      notVisible: "不可见",
      share: "分享",
      language: "语言",
      location: "位置",
      astronomicalData: "天文数据",
      altitude: "高度",
      azimuth: "方位角",
      loading: "加载中...",
      day: "日",
      month: "月",
      year: "年",
      nextNewMoonPreface: "月份新月的诞生",
      startOf: "始于",
      exactTime: "精确时间 (UTC)",
      today: "今天",
      prayerTimes: "礼拜时间",
      nextPrayer: "下一次礼拜",
      after: "将在",
      qibla: "朝向",
      useMyLocation: "使用我的当前位置",
      useMyLocationHint: "您的位置已被精确检测，所有 Falak 数据均已根据它进行校准。"
    }
  },
  fa: {
    translation: {
      appName: "Falak",
      tagline: "جایی که زمان با آسمان دیدار می‌کند",
      currentTime: "زمان کنونی",
      moonPhase: "فاز ماه",
      hijriCalendar: "تقویم هجری",
      sunrise: "طلوع آفتاب",
      sunset: "غروب آفتاب",
      solarNoon: "ظهر خورشیدی",
      dayLength: "طول روز",
      hours: "ساعت",
      moonIllumination: "روشنایی",
      moonAge: "سن ماه",
      days: "روز",
      visible: "قابل مشاهده",
      notVisible: "غیرقابل مشاهده",
      share: "اشتراک‌گذاری",
      language: "زبان",
      location: "موقعیت",
      astronomicalData: "داده‌های نجومی",
      altitude: "ارتفاع",
      azimuth: "سمت",
      loading: "در حال بارگذاری...",
      day: "روز",
      month: "ماه",
      year: "سال",
      nextNewMoonPreface: "تولد هلال ماه",
      startOf: "آغاز",
      exactTime: "زمان دقیق (UTC)",
      today: "امروز",
      prayerTimes: "اوقات نماز",
      nextPrayer: "نماز بعدی",
      after: "خواهد بود پس از",
      qibla: "جهت قبله",
      useMyLocation: "از موقعیت فعلی من استفاده کن",
      useMyLocationHint: "موقعیت شما با دقت تشخیص داده شده و تمام داده‌های فلک بر اساس آن تنظیم شده است."
    }
  },
  tr: {
    translation: {
      appName: "Falak",
      tagline: "Zamanın gökyüzüyle buluştuğu yer",
      currentTime: "Şu anki Saat",
      moonPhase: "Ay Evresi",
      hijriCalendar: "Hicri Takvim",
      sunrise: "Gün Doğumu",
      sunset: "Gün Batımı",
      solarNoon: "Güneş Öğlesi",
      dayLength: "Gün Uzunluğu",
      hours: "saat",
      moonIllumination: "Aydınlanma",
      moonAge: "Ay Yaşı",
      days: "gün",
      visible: "Görünür",
      notVisible: "Görünmez",
      share: "Paylaş",
      language: "Dil",
      location: "Konum",
      astronomicalData: "Astronomik Veriler",
      altitude: "Yükseklik",
      azimuth: "Azimut",
      loading: "Yükleniyor...",
      day: "Gün",
      month: "Ay",
      year: "Yıl",
      nextNewMoonPreface: "Ayın hilalinin doğuşu",
      startOf: "Başlangıç",
      exactTime: "Tam Zaman (UTC)",
      today: "Bugün",
      prayerTimes: "Namaz Vakitleri",
      nextPrayer: "Sonraki namaz",
      after: "Şu süre içinde olacak",
      qibla: "Kıble Yönü",
      useMyLocation: "Mevcut konumumu kullan",
      useMyLocationHint: "Konumunuz hassas bir şekilde tespit edildi ve tüm Falak verileri buna göre kalibre edildi."
    }
  },
  es: {
    translation: {
      appName: "Falak",
      tagline: "Donde el tiempo se encuentra con el cielo",
      currentTime: "Hora Actual",
      moonPhase: "Fase Lunar",
      hijriCalendar: "Calendario Hégira",
      sunrise: "Amanecer",
      sunset: "Atardecer",
      solarNoon: "Mediodía Solar",
      dayLength: "Duración del Día",
      hours: "horas",
      moonIllumination: "Iluminación",
      moonAge: "Edad de la Luna",
      days: "días",
      visible: "Visible",
      notVisible: "No Visible",
      share: "Compartir",
      language: "Idioma",
      location: "Ubicación",
      astronomicalData: "Datos Astronómicos",
      altitude: "Altitud",
      azimuth: "Azimut",
      loading: "Cargando...",
      day: "Día",
      month: "Mes",
      year: "Año",
      nextNewMoonPreface: "Nacimiento del creciente del mes",
      startOf: "Inicio de",
      exactTime: "Hora Exacta (UTC)",
      today: "Hoy",
      prayerTimes: "Horarios de Oración",
      nextPrayer: "Próxima oración",
      after: "Será en",
      qibla: "Dirección de la Qibla",
      useMyLocation: "Usar mi ubicación actual",
      useMyLocationHint: "Tu ubicación se detecta con precisión y todos los datos de Falak están calibrados según ella."
    }
  },
  pt: {
    translation: {
      appName: "Falak",
      tagline: "Onde o tempo encontra o céu",
      currentTime: "Hora Atual",
      moonPhase: "Fase da Lua",
      hijriCalendar: "Calendário Hégira",
      sunrise: "Nascer do Sol",
      sunset: "Pôr do Sol",
      solarNoon: "Meio-dia Solar",
      dayLength: "Duração do Dia",
      hours: "horas",
      moonIllumination: "Iluminação",
      moonAge: "Idade da Lua",
      days: "dias",
      visible: "Visível",
      notVisible: "Não Visível",
      share: "Compartilhar",
      language: "Idioma",
      location: "Localização",
      astronomicalData: "Dados Astronômicos",
      altitude: "Altitude",
      azimuth: "Azimute",
      loading: "Carregando...",
      day: "Dia",
      month: "Mês",
      year: "Ano",
      nextNewMoonPreface: "Nascimento do crescente do mês",
      startOf: "Início de",
      exactTime: "Hora Exata (UTC)",
      today: "Hoje",
      prayerTimes: "Horários de Oração",
      nextPrayer: "Próxima oração",
      after: "Será em",
      qibla: "Direção da Qibla",
      useMyLocation: "Usar a minha localização atual",
      useMyLocationHint: "A sua localização é detectada com precisão e todos os dados do Falak são calibrados de acordo com ela."
    }
  },
  de: {
    translation: {
      appName: "Falak",
      tagline: "Wo Zeit auf den Himmel trifft",
      currentTime: "Aktuelle Uhrzeit",
      moonPhase: "Mondphase",
      hijriCalendar: "Hidschri-Kalender",
      sunrise: "Sonnenaufgang",
      sunset: "Sonnenuntergang",
      solarNoon: "Sonnenmittag",
      dayLength: "Tageslänge",
      hours: "Stunden",
      moonIllumination: "Beleuchtung",
      moonAge: "Mondalter",
      days: "Tage",
      visible: "Sichtbar",
      notVisible: "Nicht sichtbar",
      share: "Teilen",
      language: "Sprache",
      location: "Standort",
      astronomicalData: "Astronomische Daten",
      altitude: "Höhe",
      azimuth: "Azimut",
      loading: "Lädt...",
      day: "Tag",
      month: "Monat",
      year: "Jahr",
      nextNewMoonPreface: "Geburt der Mondsichel des Monats",
      startOf: "Beginn von",
      exactTime: "Genaue Zeit (UTC)",
      today: "Heute",
      prayerTimes: "Gebetszeiten",
      nextPrayer: "Nächstes Gebet",
      after: "Beginnt in",
      qibla: "Qibla-Richtung",
      useMyLocation: "Meinen aktuellen Standort verwenden",
      useMyLocationHint: "Ihr Standort wird präzise erfasst und alle Falak-Daten sind entsprechend kalibriert."
    }
  },
  it: {
    translation: {
      appName: "Falak",
      tagline: "Dove il tempo incontra il cielo",
      currentTime: "Ora attuale",
      moonPhase: "Fase lunare",
      hijriCalendar: "Calendario dell'Egira",
      sunrise: "Alba",
      sunset: "Tramonto",
      solarNoon: "Mezzogiorno solare",
      dayLength: "Durata del giorno",
      hours: "ore",
      moonIllumination: "Illuminazione",
      moonAge: "Età della Luna",
      days: "giorni",
      visible: "Visibile",
      notVisible: "Non visibile",
      share: "Condividi",
      language: "Lingua",
      location: "Posizione",
      astronomicalData: "Dati astronomici",
      altitude: "Altitudine",
      azimuth: "Azimut",
      loading: "Caricamento...",
      day: "Giorno",
      month: "Mese",
      year: "Anno",
      nextNewMoonPreface: "Nascita della falce di luna del mese",
      startOf: "Inizio di",
      exactTime: "Ora esatta (UTC)",
      today: "Oggi",
      prayerTimes: "Orari di preghiera",
      nextPrayer: "Prossima preghiera",
      after: "Sarà tra",
      qibla: "Direzione della Qibla",
      useMyLocation: "Usa la mia posizione attuale",
      useMyLocationHint: "La tua posizione viene rilevata con precisione e tutti i dati di Falak sono calibrati di conseguenza."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'id', 'ur', 'fr', 'bn', 'zh', 'fa', 'tr', 'es', 'pt', 'de', 'it'],
    interpolation: { escapeValue: false }
  });

export default i18n;
